// CFL-5: "this free gift also gives away an item another live gift campaign gives away" notice.
//
// A warning only, never a block. The backend adds an OPTIONAL `giftOverlaps: [{ campaign: { id, name },
// items: [{ title }] }]` to the activate response (and the coverage preview has the same field). An
// older backend simply does not send it, so every reader feature-detects and treats "absent" as
// "nothing to say". Activating from the editor navigates away right after, so the list is parked in
// sessionStorage and shown once on the campaigns list (same pattern as utils/takeoverNotice.js).
const KEY = 'primeGiftOverlapNotice';

const clean = (list) =>
  (Array.isArray(list) ? list : [])
    .filter((g) => g && g.campaign && (g.campaign.name || g.campaign.id))
    .map((g) => ({
      campaign: { id: g.campaign.id, name: String(g.campaign.name ?? g.campaign.id) },
      items: Array.isArray(g.items) ? g.items.map((i) => ({ title: i?.title ? String(i.title) : '' })) : [],
    }));

// Finds the field wherever the response envelope puts it ({ ... }, { data: { ... } }, { data: { data } }).
export const extractGiftOverlaps = (res) => {
  const candidates = [res, res?.data, res?.data?.data];
  for (const c of candidates) {
    const list = clean(c?.giftOverlaps);
    if (list.length) return list;
  }
  return [];
};

export const rememberGiftOverlaps = (list) => {
  const fresh = clean(list);
  if (!fresh.length) return;
  try {
    const prev = JSON.parse(window.sessionStorage.getItem(KEY) || '[]');
    const merged = [...(Array.isArray(prev) ? prev : [])];
    fresh.forEach((g) => {
      if (!merged.some((m) => String(m.campaign.id) === String(g.campaign.id))) merged.push(g);
    });
    window.sessionStorage.setItem(KEY, JSON.stringify(merged));
  } catch (e) {
    // storage unavailable: the notice is a nicety, never block the flow
  }
};

// Reads and clears the parked list (shown once).
export const consumeGiftOverlaps = () => {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
    return clean(JSON.parse(raw || '[]'));
  } catch (e) {
    return [];
  }
};

export const giftOverlapMessages = (t, list) =>
  clean(list).map((g) =>
    t('p.setOverlap.giftDoubleGive', {
      name: g.campaign.name,
      items: g.items.map((i) => i.title).filter(Boolean).join(', ') || String(g.items.length),
    })
  );
